import { DESKTOP, GAME_TURBO, MOBILE } from '@/consts'
import { game_detail_configs } from '@/config/games'
import { isMsaWebView, msaJsFunc } from '@/utils/msa'
import { isHorizontalWithInner } from '@/utils/platform'
import { region } from '@/utils/utils'
import {
  RENDER_TEMP,
  VPN_GAMES,
  NOT_EXTERNAL_CHECK_GAMES,
  GET_ALL_EXTERNAL_GAMES,
  EXTERNAL_CHECK_GAMES,
  IS_GAME_SERVER,
  PARALLEL_REQUESTS_GAMES,
  ENTER_ANY_GAMES,
  NOT_EXTERNAL_INPUT_SERVER_GAMES,
  GET_EXTERNAL_SERVER_CHECK_GAMES_ALL,
  NOT_EXTERNAL_SERVER_CHECK_GAMES,
  EXTERNAL_SERVER_CHECK_GAMES,
  CODE_MODEL_GAME_LIST,
  ZONE_ID_INPUT_GAMES,
} from '@page_detail/config'

import { moneyFormatRules } from '@/utils/moneyFormatRules'

import {
  is_display_desktop,
  is_display_gameTurbo,
} from '@/components/DisplayType'

import { firstFFgames } from '@/utils/storage'
const {
  has_desktopDetail_games: desktopGameList,
  has_gameTurbo_games: gameTurboGameList,
  has_coupon_games: hasCouponGames,
  no_sku_games: noSkuGames,
} = game_detail_configs

export default {
  // 是否展示横屏  返回值：true横屏/false竖屏
  displayHorizontal: (state) => {
    const { gameName, isInPubgmGameApp, isMobile, isTurbo } = state
    // 优先判断是否是pc
    if (is_display_desktop(isMobile, gameName)) return false
    // 优先判断是否是gt
    if (is_display_gameTurbo(isMobile, isTurbo)) return false
    // 判断是否在pubgm的webview中
    if (gameName === 'pubgm') return !!isInPubgmGameApp
    // 判断是否在msa的webview中
    if (gameName === 'mobile-legends') {
      // 如果是在msa中，则调用msa判断是否是横屏
      if (isMsaWebView()) return !!msaJsFunc('isLandscape')
      // 否则，根据设备是否横向来判断是否横屏
      // 注：暂时屏蔽浏览器中的横竖屏判断，跳转到浏览器中展示竖屏，等msa webview问题解决后开启
      // 本期只上印尼
      const country = region()
      if (country === 'id') return isHorizontalWithInner()
    }
    return false
  },
  // 是否展示桌面版（可能只有部分游戏支持桌面版）
  displayDesktop: (state) => {
    return state.isDesktop && desktopGameList.includes(state.gameName)
  },
  // 是否展示 Game Turbo 小窗模式（可能只有部分游戏支持小窗模式）
  displayTurbo: (state) => {
    return state.isTurbo && gameTurboGameList.includes(state.gameName)
  },
  displayMobile: (state, getters) => {
    return !getters.displayDesktop && !getters.displayTurbo
  },
  hasCouponGames: () => {
    return hasCouponGames
  },
  noSkuGames: () => {
    return noSkuGames
  },
  // 显示模式（移动版、桌面版、Game Turbo 小窗模式）
  displayMode: (state, getters) => {
    if (getters.displayDesktop) {
      return DESKTOP
    }
    if (getters.displayTurbo) {
      return GAME_TURBO
    }
    return MOBILE
  },
  displayModeClassName: (state, getters) => {
    switch (getters.displayMode) {
      case DESKTOP:
        return 'display-desktop'
      case GAME_TURBO:
        return 'display-game-turbo'
      default:
        return 'display-mobile'
    }
  },
  displayLayout: (state) => {
    return state.isDesktop
      ? 'desktop-layout'
      : state.isTurbo
      ? 'gt-layout'
      : state.isApp
      ? 'mobile-layout inApp'
      : 'mobile-layout'
  },
  // 当前页面 - 用于打点，如果是游戏页面，返回游戏名称，否则返回首页
  trackPage: (state) => {
    return state.gameName ? state.gameName : 'home'
  },
  // 打点前缀
  trackingPrefix: (state, getters) => {
    switch (getters.displayMode) {
      case DESKTOP:
        return 'pc_'
      case GAME_TURBO:
        return 'gt_'
      default:
        if (state.isApp) {
          return 'app_'
        } else {
          return 'h5_'
        }
    }
  },
  // 是否折叠支付
  usePaymentsFolding: (state, getters) => {
    return getters.displayMobile && [].includes(state.gameName)
  },
  selectedPackageKey: (state) => {
    return `@@top-selected-skuid-${state.gameName}`
  },
  selectedPaymentIdKey: (state) => {
    return `@@top-selected-channelId-${state.gameName}`
  },
  selectedUidKey: (state) => {
    return `@@top-selected-uid-${state.gameName}`
  },
  selectedServiceKey: (state) => {
    return `@@top-selected-service-${state.gameName}`
  },

  // 每次校验的时候需要获取成功的key进行回显
  selectedSuccessServiceKey: (state) => {
    return `@@top-selected-service-success-${state.gameName}`
  },
  // 是否为分销用户
  isDistributor: (state) => {
    return state.userInfo && state.userInfo.userType === 1
  },
  // app跳转baseurl
  appBaseUrl: (state) => {
    return typeof window === 'undefined'
      ? `/`
      : `${window.location.origin}/${state.region}`
  },
  isNew: (state) => {
    return state.layoutVersion === 'version-2'
  },
  isNewClass: (state) => {
    const isNew = state.layoutVersion === 'version-2'
    return isNew ? 'is-new' : ''
  },
  isNewLayout: (state) => {
    return ['version-2', 'version-2-2'].includes(state.layoutVersion)
  },

  isRuPubgm: (state) => {
    return !!(
      state.gameName === 'pubgm' &&
      state.region === 'ru' &&
      state.userInfo === null
    )
  },
  // 是否原神【不能点击优惠券弹层展开的功能】
  isGenshin(state) {
    return (
      state.gameName === 'genshin' &&
      state.region === 'ru' &&
      state.userInfo === null
    )
  },
  // 是否登录
  isLogin(state) {
    return !!(state.userInfo !== null && state.userInfo?.kicoinId)
  },
  //是否是新模版游戏
  isGameABtest(state) {
    return RENDER_TEMP.includes(state.gameName)
  },
  // VPN 相关的两个CP
  isVpnGames(state) {
    return VPN_GAMES.includes(state.gameName)
  },

  // 暖暖的翻译全是英文
  isShiningNikki(state) {
    return state.gameName === 'shining-nikki'
  },

  // 需要输入 UID + Zone ID 的游戏
  isZoneIdInputGame(state) {
    return ZONE_ID_INPUT_GAMES.includes(state.gameName)
  },
  // 切换SKU的时候需要验证UID
  isMLBB(state) {
    return state.gameName === 'mobile-legends'
  },
  // 当前国家是否为欧洲，货币符号在后面
  isEuropeCountry() {
    return moneyFormatRules.SymbolInAfter
  },
  // [外部SKU]不用校验UID的CP\灌注外部SKU的数据
  isNotCheckGames(state) {
    return NOT_EXTERNAL_CHECK_GAMES.includes(state.gameName)
  },
  // [外部SKU] 只有一个UID、「需要校验」
  isExternalCheckGames(state) {
    return EXTERNAL_CHECK_GAMES.includes(state.gameName)
  },
  // 是否为外部的SKU
  isAllExternalGames(state) {
    return GET_ALL_EXTERNAL_GAMES.includes(state.gameName)
  },
  // 默认请求server服务器的接口
  isGameServers(state) {
    return IS_GAME_SERVER.includes(state.gameName)
  },
  // 可以输入任意字符的game
  isEnterAnyGames(state) {
    return ENTER_ANY_GAMES.includes(state.gameName)
  },
  // 功夫的下单的参数需要特殊处理
  isKungfuLegend(state) {
    return state.gameName === 'kungfu-legend'
  },
  // 【infinity-kingdom】的下单的参数需要特殊处理
  isInfinityKingdom(state) {
    return state.gameName === 'infinity-kingdom'
  },
  // 【star-maker】ru 文案单独处理
  isRuStarMaker(state) {
    return state.gameName === 'star-maker' && state.region === 'ru'
  },
  // 【onmyoji-arena】的下单的参数需要特殊处理
  isOnmyojiArena(state) {
    return state.gameName === 'onmyoji-arena'
  },
  // 【onmyoji-arena】的下单的参数需要特殊处理
  isCpMd(state) {
    return state.gameName === 'md'
  },
  // 绑定手机号、只对【俄罗斯、印尼】 && isMobile 显示
  isRenderBindInfo(state) {
    const sc = ['ru', 'id']
    return !!(state.isMobile && sc.includes(state.region))
  },
  firstCacheGamesKey(state) {
    return `${firstFFgames}-${state.gameName}`
  },
  isGenshinEn(state) {
    return state.gameName === 'genshin-en'
  },
  // 全部用英文的游戏列表
  allGameLangEnglish(_, getters) {
    return getters.isGenshinEn || getters.isShiningNikki
  },
  // 特殊处理的三行并行请求的游戏列表
  isParallelRequestsGame(state) {
    return PARALLEL_REQUESTS_GAMES.includes(state.gameName)
  },
  // 是否渲染客户端引流的组件[仅限于H5展示 && 新模版]
  isRenderAppBanner(state) {
    if (state.isTurbo || state.isApp) return false
    if (state.isMobile && state.region === 'ru') return true
    return false
  },
  // SS的游戏单独处理
  isStateOfSurvival(state) {
    return state.gameName === 'state-of-survival'
  },
  // my斗罗的使用繁体中文
  isMySoulLand3d(state) {
    return state.gameName === 'soul-land3d' && state.region === 'my'
  },
  isNotExternalInputServerGames(state) {
    return NOT_EXTERNAL_INPUT_SERVER_GAMES.includes(state.gameName)
  },
  isGetExternalServerCheckGamesAll(state) {
    return GET_EXTERNAL_SERVER_CHECK_GAMES_ALL.includes(state.gameName)
  },
  isNotExternalServerCheckGames(state) {
    return NOT_EXTERNAL_SERVER_CHECK_GAMES.includes(state.gameName)
  },
  isExternalServerCheckGames(state) {
    return EXTERNAL_SERVER_CHECK_GAMES.includes(state.gameName)
  },
  // 是否为全部code模式的游戏、单独做处理
  isGameCodeMode(state) {
    return CODE_MODEL_GAME_LIST.includes(state.gameName)
  },
  isGameOfKhans(state) {
    return state.gameName === 'game-of-khans'
  },
  // 首页显示的规则「abtest 秒杀」
  isLimitH5(state) {
    return !!(
      state.isMobile &&
      state.region === 'ru' &&
      !state.isTurbo &&
      !state.isApp
    )
  },
  // 详情显示的规则「abtest 秒杀」
  seckillDetailsABtest(state, getters) {
    const games = ['pubgm', 'mobile-legends', 'genshin']
    return !!(getters.isLimitH5 && games.includes(state.gameName))
  },
  isHotCpTaxIncrease(state) {
    const games = ['pubgm', 'mobile-legends']
    return games.includes(state.gameName) && state.region === 'ru'
  },
  // 品牌升级通知条是否显示（与 BrandUpgradeNoticeBar 同步，供其它页面使用）
  brandUpgradeNoticeVisible(state) {
    return !!(state.common && state.common.brandUpgradeNoticeVisible)
  },
}
